import { fromJS } from 'immutable';
import get from 'lodash/get';

import { RESET_STORE } from 'containers/LoginPage/constants';
import { FeeNoteAction } from 'containers/LawyerFeeNote/typings';
import {
  SET_CREATE_FEE_NOTE,
  SET_FEE_NOTES,
  SET_SEARCH,
  SET_ALL_FEE_NOTES,
  REQUEST_SET_KPI_OVERDUE_INVOICE,
} from 'containers/LawyerFeeNote/constants';
import { SET_FEE_NOTES_GPO } from 'containers/PreOpenManagerFeeNote/constants';

const initialState = fromJS({
  feeNotes: [],
  feeNotesCount: 0,
  allFeeNotes: [],
  kpiOverDueInvoice: {},
});

const feeNoteReducer = (state = initialState, action: FeeNoteAction) => {
  switch (action.type) {
    case SET_FEE_NOTES:
      const notes = get(action, ['data'], []);
      return state
        .set('feeNotes', fromJS(get(notes, 'feeNotes', [])))
        .set('feeNotesCount', fromJS(get(notes, 'feeNotesCount', 0)));
    case SET_ALL_FEE_NOTES:
      const allNotes = get(action, ['data'], []);
      return state.set('allFeeNotes', fromJS(allNotes));
    case SET_CREATE_FEE_NOTE:
      const note = get(action, ['data'], {});
      return state
        .set('feeNotes', fromJS([...state.toJS().feeNotes, note]))
        .set('feeNotesCount', fromJS(state.toJS().feeNotes.length + 1));
    case SET_SEARCH:
      const searchNotes = get(action, ['data'], []);
      return state
        .set('feeNotes', fromJS(searchNotes))
        .set('feeNotesCount', fromJS(searchNotes.length));
    case SET_FEE_NOTES_GPO:
      const gpoNotes = get(action, ['data'], []);
      return state
        .set('feeNotes', fromJS(get(gpoNotes, 'feeNotes', [])))
        .set('feeNotesCount', fromJS(get(gpoNotes, 'feeNotesCount', 0)));
    case REQUEST_SET_KPI_OVERDUE_INVOICE:
      return state.set('kpiOverDueInvoice', fromJS(get(action, 'payload', {})));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default feeNoteReducer;
